import { ILanguage } from 'graphql/types';

export const LANGUAGES = Object.keys(ILanguage).reduce(
    (acc, curVal) => ({
        ...acc,
        [ILanguage[curVal]]: `languages.${curVal.toLowerCase()}`,
    }),
    {} as { [key: string]: string }
);

export interface IAITranslationLanguage {
    /** English name sent to the backend AI prompt as the target language. */
    value: string;
    translationKey: string;
    flag: string;
}

export const AI_TRANSLATION_LANGUAGES: IAITranslationLanguage[] = [
    { value: 'Indonesian', translationKey: 'id', flag: '🇮🇩' },
    { value: 'Malay', translationKey: 'ms', flag: '🇲🇾' },
    { value: 'Bulgarian', translationKey: 'bg', flag: '🇧🇬' },
    { value: 'Czech', translationKey: 'cs', flag: '🇨🇿' },
    { value: 'Danish', translationKey: 'da', flag: '🇩🇰' },
    { value: 'German', translationKey: 'de', flag: '🇩🇪' },
    { value: 'English', translationKey: 'en', flag: '🇬🇧' },
    { value: 'Spanish', translationKey: 'es', flag: '🇪🇸' },
    { value: 'French', translationKey: 'fr', flag: '🇫🇷' },
    { value: 'Croatian', translationKey: 'hr', flag: '🇭🇷' },
    { value: 'Italian', translationKey: 'it', flag: '🇮🇹' },
    { value: 'Hungarian', translationKey: 'hu', flag: '🇭🇺' },
    { value: 'Dutch', translationKey: 'nl', flag: '🇳🇱' },
    { value: 'Norwegian Bokmål', translationKey: 'nb', flag: '🇳🇴' },
    { value: 'Papiamento', translationKey: 'pap', flag: '🇨🇼' },
    { value: 'Polish', translationKey: 'pl', flag: '🇵🇱' },
    { value: 'Portuguese', translationKey: 'pt', flag: '🇵🇹' },
    { value: 'Romanian', translationKey: 'ro', flag: '🇷🇴' },
    { value: 'Slovak', translationKey: 'sk', flag: '🇸🇰' },
    { value: 'Slovenian', translationKey: 'sl', flag: '🇸🇮' },
    { value: 'Finnish', translationKey: 'fi', flag: '🇫🇮' },
    { value: 'Swedish', translationKey: 'sv', flag: '🇸🇪' },
    { value: 'Vietnamese', translationKey: 'vi', flag: '🇻🇳' },
    { value: 'Turkish', translationKey: 'tr', flag: '🇹🇷' },
    { value: 'Greek', translationKey: 'el', flag: '🇬🇷' },
    { value: 'Russian', translationKey: 'ru', flag: '🇷🇺' },
    { value: 'Ukrainian', translationKey: 'uk', flag: '🇺🇦' },
    { value: 'Bengali', translationKey: 'bn', flag: '🇧🇩' },
    { value: 'Tamil', translationKey: 'ta', flag: '🇮🇳' },
    { value: 'Hindi', translationKey: 'hi', flag: '🇮🇳' },
    { value: 'Thai', translationKey: 'th', flag: '🇹🇭' },
    { value: 'Chinese', translationKey: 'zh', flag: '🇨🇳' },
    { value: 'Japanese', translationKey: 'ja', flag: '🇯🇵' },
    { value: 'Korean', translationKey: 'ko', flag: '🇰🇷' },
];
